import React from "react";
import type { AppConfig } from "../../types/appConfig";

export type { AppConfig } from "../../types/appConfig";
export { isValidAppConfig } from "../../types/appConfig";

export const AppConfigContext = React.createContext<AppConfig>(null!);
